module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n    " + _vm._s(_vm.emailables.length) + " emails\n    "), _c('div', {
    staticClass: "pull-right"
  }, [_c('report-settings'), _vm._v("\n         \n        "), _c('a', {
    staticClass: "button is-primary pull-right",
    attrs: {
      "href": '/api/reports/emails?company=' + _vm.reportCompany
    }
  }, [_vm._v("Download in Excel")])], 1), _vm._v(" "), _c('div', {
    staticClass: "is-clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('data-table', {
    attrs: {
      "data-set": _vm.emailables,
      "page-length": 50,
      "columns": [{
          name: 'Contact',
          prop: ['first_name', 'last_name'],
          type: 'text'
        },
        {
          name: 'Email',
          prop: 'email',
          type: 'text'
        },
        {
          name: 'Source',
          prop: 'source',
          type: 'text'
        } ]
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39aa8e83"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/mailing/EmailList.vue
// module id = 524
// module chunks = 0